import React, { useState, useCallback, useEffect } from 'react'
import style from '../../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import * as config from '../../../next.config'
import axios from "axios";
import Avatar from '@mui/material/Avatar'
import { printLogs } from '../../helpers/helpers'
import { useRouter, Router } from "next/router";
import { constants } from "../../../constants"
import Link from "next/link";
import ConfirmDialog from '../../components/Dialogs/ConfirmDialog'
import { getCookieValue } from "../../helpers/helpers"
import AlertDialog from '../../components/Dialogs/AlertDialog'
import RatingDialog from '../../components/Dialogs/RatingDialog'
import { getImage } from '../../helpers/images'
function Cards({ reservation, callbackReload }) {
    const { t } = useTranslation("common")
    const { locale } = useRouter();
    const [image, setImage] = useState("")
    let currentTime = Date.parse(new Date());
    const [RatingByUser, setRatingByUser] = useState(null);
    const [DialogData, setDialogData] = useState({
        open: false,
        Type: " ",
        Text: ""
    })
    const [RatingDialogData, setRatingDialogData] = useState({
        open: false,
        Type: "",
        Text: "",
        entityDetailsId: "",
        OpretionType: "",

    })
    const [confirmDialog, setConfirmDialog] = useState({
        open: false,
        Type: " ",
        Text: "",
        confirmBtnTitle: "",
        loading: false,
        data: "",
        OpretionType: ""
    })
    let patientNamelength = reservation.patientName.length
    let ReservationEidt
    let slug

    let timestampToDate = new Date(reservation.dateOfReservation);
    if (reservation.entityDetails && reservation.entityDetails.length > 0) {
        slug = reservation.entityDetails[0].slug.length > 0 ? reservation.entityDetails[0].slug[0].url : reservation.entityDetails[0].id
        ReservationEidt = "/" + reservation.entityDetails[0].entityType[0].code + "/" + slug + "/book".replace("/[^a-zA-Z0-9-_]/g", "")
    }
    let time = timestampToDate.toLocaleTimeString("ar", {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric"
    });



    const vistedCustomer = (data) => {

        axios({
            method: "POST",
            url: `${config["basePath"]}/api/reservation/patch/customer/visitedByCustomer`,
            data: { id: data.id, note: "this is by " + getCookieValue("fullName") },
            headers: {
                "Content-Type": "application/json",
                "accept-language": locale
            }
        })
            .then(resp => {
                //   printLogs("resp==sss",resp)
                if (resp.data.data != null) {
                    setConfirmDialog({
                        open: false
                    })
                    setDialogData({
                        open: true,
                        Type: "success",
                        Text: t("ReservationconfirmText")
                    })


                }
                else {
                    setConfirmDialog({
                        open: false
                    })
                    setDialogData({
                        open: true,
                        Type: "error",
                        Text: resp.data.data.subErrors[0].message
                    })

                }
            })
            .catch(error => printLogs(error));
    };
    const cancelReservation = (data, Note) => {

        axios({
            method: "POST",
            url: `${config["basePath"]}/api/reservation/patch/customer/operationForCustomer`,
            data: {
                id: data.id,
                entityDetailsId: data.entityDetailsId,
                note: Note != null ? Note : " this is canceled by" + getCookieValue("fullName"),
                "operation": "delete"
            },
            headers: {
                "Content-Type": "application/json",
                "accept-language": locale
            }
        })
            .then(resp => {
                // console.log("resp=======>", resp)

                if (resp.data.data.successful.count > 0) {


                    setConfirmDialog({
                        open: false
                    })
                    setDialogData({
                        open: true,
                        Type: "success",
                        Text: t("cancelText")
                    })

                }
                else {
                    // console.log("else=====>")
                    setConfirmDialog({
                        open: false
                    })
                    setDialogData({
                        open: true,
                        Type: "error",
                        Text: resp.data.data.unsuccessful.objects[0].errors

                    })

                }
            })
            .catch(error => printLogs("error====>", error));
    };

    const callback = useCallback(
        (back) => {

            if (back != null) {

                setDialogData({
                    open: back.open,
                    Type: back.Type,
                    Text: back.Text
                })


                setRatingDialogData({
                    open: false,

                })


            }
        },
        [DialogData],
    )
    useEffect(() => {

        if (reservation && reservation.entityDetails.length > 0 && reservation.entityDetails[0].images.length > 0 && reservation.entityDetails[0].images[0].files != null) {
            getImage(reservation.entityDetails[0].images[0].files.fileId, reservation.entityDetails[0].images[0].files.filePath).then(res => {
                if (res != '') {
                    setImage(res)
                }
            })
        }
        if (reservation.RatingByUser && reservation.RatingByUser.length > 0 && reservation.RatingByUser[0].evaluateId == reservation.entityDetailsId) {
            setRatingByUser(reservation.RatingByUser[0])
        }
    }, [reservation])
    return (
        <div className={style.mybookingsGrid}>
            <div className={style.stylesComfirmationpage}>
                <div className={reservation.status && reservation.status[0].code == "closed" ? style.PinkBG : reservation.status && reservation.status[0].code == "approved" ? style.BgTeal : reservation.status && reservation.status[0].code == "pending-approval-for-create" ? style.BgGrey2 : style.BgYellow}>
                    <div className={style.TwoFlex}>
                        <div className={style.textaboutdoctor3 + " " + style.Blod + " " + style.White + " " + style.textalign} >
                            <div>{"#" + reservation.id} </div>
                            <div>{time}</div>

                        </div>
                        <div className={style.textaboutdoctor3 + " " + style.Blod + " " + style.White} >{reservation.status && reservation.status.length > 0 && reservation.status.filter(d => d.language.code == locale).length > 0 ? reservation.status.filter(d => d.language.code == locale)[0].name : ""}
                            {reservation.status && reservation.status.length > 0 && reservation.status.filter(d => d.language.code == locale && d.code == "approved").length > 0 && reservation.visitedByCustomer == true ? ("(" + t("confirmed") + ")") : reservation.status && reservation.status.length > 0 && reservation.status.filter(d => d.language.code == locale && d.code == "approved").length > 0 && reservation.visitedByCustomer == false ? ("(" + t("notconfirmed") + ")") : ""}</div>
                    </div>
                </div>

                <div className={style.FourGrid}>
                    <div className={style.FlexColumn}>
                        <div>
                            <Avatar
                                alt="Profile" src={image && image != "" ? image :
                                    `${config.basePath}/assest/Group 5843.svg`}
                                className={style.sizeAvatar} />
                        </div>
                        <div>

                            <p className={style.textaboutdoctor3 + " " + style.Blod + " " + style.TealColor} >
                                {t("ClinicName")} : <span className={style.ColorBlack}> {reservation && reservation.entityDetails.length > 0 && reservation.entityDetails[0].transEntityDetails.filter(ele => ele.language.length && ele.language[0].code == locale).length > 0 ? reservation.entityDetails[0].transEntityDetails.filter(ele => ele.language.length && ele.language[0].code == locale)[0].officialName : reservation.entityDetails.length && reservation.entityDetails[0].transEntityDetails[0].officialName}</span></p>

                        </div>
                    </div>
                    <div className={style.FlexColumn + " " + style.alignInitial}>
                        <div className={style.textaboutdoctor2 + " " + style.Blod + " " + style.PinkColor + " " + style.textalign}>
                            {t("patientData")}
                        </div>

                        <div>
                            <p className={style.textaboutdoctor3 + " " + style.Blod + " " + style.TealColor + " " + style.textalign} >
                                {t("patientName")} : <span className={style.ColorBlack}>   {patientNamelength > 25 ? reservation.patientName.substring(0, 20) + "......" : reservation.patientName}</span></p>
                        </div>
                        <div>
                            <p className={style.textaboutdoctor3 + " " + style.Blod + " " + style.TealColor + " " + style.textalign} >
                                {t("patientPhone")} : <span className={style.ColorBlack}> {reservation.patientMobile}</span></p>
                        </div>
                        {reservation.entityDetails.length > 0 ?
                            <div>
                                <p className={style.textaboutdoctor3 + " " + style.Blod + " " + style.TealColor + " " + style.textalign} >
                                    {t("TheAddress")} : <span className={style.ColorBlack}>   {
                                        reservation.entityDetails[0].address.filter(
                                            i => i.permanent == true
                                        )[0].physicalAddress
                                    }</span></p>
                            </div>
                            : ""}



                    </div>

                    <div className={style.FlexColumn + " " + style.alignInitial}>
                        <div className={style.textaboutdoctor2 + " " + style.Blod + " " + style.PinkColor + " " + style.textalign}>
                            {t("BookData")}
                        </div>

                        <div>
                            <p className={style.textaboutdoctor3 + " " + style.Blod + " " + style.TealColor + " " + style.textalign} >
                                {t("Amount")} : <span className={style.ColorBlack}>  {reservation.productUnitPrice.length > 0 ? reservation.productUnitPrice[0].price : ""}{" "}
                                    {reservation.productUnitPrice.length > 0 ? reservation.productUnitPrice[0].currency.transCurrency.filter(d => d.language.code == locale).length > 0 ? reservation.productUnitPrice[0].currency.transCurrency.filter(d => d.language.code == locale)[0].name : reservation.productUnitPrice[0].currency.transCurrency[0].name : ""}{" "}


                                </span>
                            </p>
                        </div>
                        <div>

                            <p className={style.textaboutdoctor3 + " " + style.Blod + " " + style.TealColor + " " + style.textalign} >
                                {t("Payment")} : <span className={style.ColorBlack}>


                                    {reservation.paymentType && reservation.paymentType.length > 0 && reservation.paymentType.filter(d => d.language.code == locale).length > 0 ? reservation.paymentType.filter(d => d.language.code == locale)[0].name : ""}
                                </span>
                            </p>
                        </div>
                        <div>
                            <p className={style.textaboutdoctor3 + " " + style.Blod + " " + style.TealColor + " " + style.textalign} >
                                {t("NameofProduct")} : <span className={style.ColorBlack}>  {reservation.product ? reservation.product.transProduct.filter(i => i.language && i.language.code == locale).length > 0 ? reservation.product.transProduct.filter(i => i.language && i.language.code == locale)[0].name : reservation.product.transProduct[0].name : ""}</span></p>
                        </div>

                        {reservation.sourceCurrency && <div>
                            <p className={style.textaboutdoctor3 + " " + style.Blod + " " + style.TealColor + " " + style.textalign} >
                                {t("fromAccount")} : <span className={style.ColorBlack}>  {reservation.sourceCurrency ? reservation.sourceCurrency.transCurrency.filter(i => i.language && i.language.code == locale).length > 0 ? reservation.sourceCurrency.transCurrency.filter(i => i.language && i.language.code == locale)[0].name : reservation.sourceCurrency.transCurrency[0].name : ""}</span></p>
                        </div>}



                    </div>
                    <div className={style.FlexColumn + " " + style.alignInitial}>
                        <div className={style.textaboutdoctor2 + " " + style.Blod + " " + style.PinkColor + " " + style.textaligncenter}>
                            {t("Operations")}
                        </div>

                        <div className={style.TwoFlexButton}>
                            {reservation.status && reservation.status[0].code == "pending-approval-for-create" ?

                                <Link href={{
                                    pathname: "/" + constants.entityLink + ReservationEidt,
                                    query: { reservationId: reservation.id }
                                }}>

                                    <button className={style.borderBtnBooking + " " + style.BgYellow + "  " + style.White} onClick={e => {
                                        if (e.target != null) {


                                        }
                                    }}>تعديل </button>
                                </Link>
                                : ""}
                            {
                                reservation.status[0].code ==
                                    "pending-approval-for-create" ?
                                    <>
                                        <button className={style.borderBtnBooking + " " + style.PinkBG + "  " + style.White}
                                            onClick={e => {
                                                if (e.target != null) {
                                                    setConfirmDialog({
                                                        open: true,
                                                        Type: "success",
                                                        Text: t("cancelconfirmText"),
                                                        confirmBtnTitle: t("Ok"),
                                                        data: reservation,
                                                        OpretionType: "cancel"

                                                    })
                                                }

                                            }
                                            }>{t("btnCancel")}</button>
                                    </>
                                    : ""}
                        </div>
                        <div className={style.TwoFlexButton}>

                            {reservation.status[0].code != "pending-approval-for-create" &&
                                reservation.status[0].code != "closed" &&
                                timestampToDate < currentTime &&
                                reservation.visitedByCustomer == false
                                ?
                                <>
                                    <button className={style.borderBtnBooking + " " + style.BgTeal + "  " + style.White}
                                        onClick={e => {
                                            if (e.target != null) {
                                                setConfirmDialog({
                                                    open: true,
                                                    Type: "success",
                                                    Text: t("confirmText"),
                                                    confirmBtnTitle: t("confirmTitle"),
                                                    data: reservation,
                                                    OpretionType: "confirm"
                                                })
                                            }

                                        }
                                        }>{t("Comfirmation")}</button>
                                </>
                                : ""}

                            {reservation.status[0].code != "pending-approval-for-create" &&
                                reservation.status[0].code != "closed" &&
                                timestampToDate < currentTime &
                                reservation.confirmFromClinic == true ?
                                <>
                                    <button className={style.borderBtnBooking + " " + style.BgGrey2 + "  " + style.White}
                                        onClick={e => {
                                            if (e.target != null) {
                                                setRatingDialogData({
                                                    open: true,
                                                    Type: "success",
                                                    Text: t("Rating"),
                                                    entityDetailsId: reservation.entityDetailsId,
                                                    OpretionType: "Rating",


                                                })
                                            }

                                        }}>{t("Rating")}</button>
                                </>
                                : ""}
                        </div>

                    </div>
                </div>
            </div>

            <ConfirmDialog open={confirmDialog.open}
                text={confirmDialog.Text}
                type={confirmDialog.Type}
                confirmBtnTitle={confirmDialog.confirmBtnTitle}
                loading={confirmDialog.loading}
                OpretionType={confirmDialog.OpretionType}
                btnOk={() => {
                    if (confirmDialog.OpretionType == "confirm") {
                        vistedCustomer(confirmDialog.data)
                        setConfirmDialog({
                            open: true,
                            Type: "success",
                            Text: t("confirmText"),
                            confirmBtnTitle: t("confirmTitle"),
                            loading: true
                        })

                    }

                    if (confirmDialog.OpretionType == "cancel") {
                        cancelReservation(confirmDialog.data)
                        setConfirmDialog({
                            open: true,
                            Type: "success",
                            Text: t("cancelconfirmText"),
                            confirmBtnTitle: t("Ok"),
                            loading: true
                        })
                    }


                }}
                callBack={(data, call) => {
                    if (confirmDialog.OpretionType == "cancel") {
                        cancelReservation(confirmDialog.data, data[0])
                        setConfirmDialog({
                            open: true,
                            Type: "success",
                            Text: t("cancelconfirmText"),
                            confirmBtnTitle: t("Ok"),
                            loading: true,
                            OpretionType: "cancel"
                        })
                    }

                }}
                btnCancel={() => {
                    setConfirmDialog({
                        open: false
                    })

                }} />
            {/* {console.log("DialogText===========>",DialogData)} */}
            <AlertDialog open={DialogData.open}
                text={DialogData.Text}
                type={DialogData.Type}
                btnOk={() => {
                    setDialogData({ open: false })
                    callbackReload(true)
                }}
            />

            {RatingDialogData.open == true ?
                <RatingDialog open={RatingDialogData.open}
                    text={RatingDialogData.Text}
                    type={RatingDialogData.Type}
                    entityDetailsId={RatingDialogData.entityDetailsId}
                    callback={callback}
                    updateRating={RatingByUser}
                    btnCancel={() => {
                        setRatingDialogData({
                            open: false
                        })
                    }}
                />
                : ""}
        </div>
    )
}

export default Cards
